<template>
    <v-card>
        <v-card-title class="font-italic grey--text darken-3 text-uppercase">{{ $t('price&quantity') }}</v-card-title>
        <v-card-text class="pb-0">
            <v-row>
                <v-col cols="6" md="2">
                    <v-text-field
                        v-model.number="data.price"
                        :label="$t('price')"
                        color="teal lighten-2"
                    ></v-text-field>
                </v-col>
                <v-col cols="6" md="2">
                    <v-autocomplete
                        v-model="data.currency_id"
                        :label="$t('currency')"
                        :items="currencies"
                        color="teal lighten-2"
                        item-color="teal lighten-2"
                        item-text="name"
                        item-value="id"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="8" md="4">
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                v-model.number="data.quantity"
                                :label="$t('quantity')"
                                color="teal lighten-2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                v-model="data.unit_id"
                                :label="$t('unitOfMeasure')"
                                :items="units"
                                item-text="name"
                                item-value="id"
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="4" md="2">
                    <v-text-field
                        v-model.number="data.discount"
                        :label="$t('discount') + ' %'"
                        color="teal lighten-2"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col clos="12" class="caption font-italic text-center font-weight-bolder">
                    {{ order.product.withNds ? $t('priceWithNds') : $t('priceWithoutNds') }}
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    import { MixinOrderInfo } from '../../../mixins';
    import { InfoService } from '../../../services';

    export default {
        name: 'PriceInfo',
        mixins: [MixinOrderInfo],
        data() {
            return {
                units: [],
                key: 'priceInfo',
            }
        },
        computed: {
            currencies() {
                return this.$store.getters.currencies.map(item => ({ ...item, name: item.name.toUpperCase() }));
            },
        },
        methods: {
            getUnits() {
                InfoService.getQuantityUnits()
                    .then(res => {
                        this.units = res.data;
                    })
                    .catch(console.log);
            },
            orderHandle(value) {
                const { price, currency, quantity, discount } = value;
                this.data = {
                    price,
                    discount,
                    quantity: quantity.value,
                    unit_id: quantity.unit_id,
                    currency_id: currency.id,
                };
            }
        },
        created() {
            this.getUnits();
        },
    }
</script>

<style scoped>

</style>
